// themes/js/modules/qrcode.js
// Dynamic loader: wstrzykuje qrcode.min.js i zwraca Promise z QRCode

const QR_SCRIPT_SRC = "/themes/js/qrcode.min.js"; // upewnij się, że plik tam leży

async function ensureQRCode() {
    if (window.QRCode) return window.QRCode;
    if (ensureQRCode._loading) return ensureQRCode._loading;

    ensureQRCode._loading = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = QR_SCRIPT_SRC;
        s.async = true;

        s.onload = () => {
            ensureQRCode._loading = null;
            if (window.QRCode) resolve(window.QRCode);
            else reject(new Error("QRCode did not initialize"));
        };

        s.onerror = () => {
            ensureQRCode._loading = null;
            reject(new Error("Failed to load qrcode.min.js"));
        };

        document.head.appendChild(s);
    });

    return ensureQRCode._loading;
}

export default ensureQRCode;
